import assign from 'lodash/assign';

// Constellation
import { Box, Checkbox, FieldSet, Label, LabeledControl, Legend, VisuallyHidden } from '@zillow/constellation-10';

// Components
import FilterWrapper from '../FilterWrapper';

// Flux
import { useAppSelector } from '../../flux/configureStore';

// Misc / Utils
import { useOptimisticReducer } from '../../utils/hooks';

// Types
import type { PartialFilterType, propertyTypesType } from '../../models/Types';

const PropertyType = ({ onFilterChange }: { onFilterChange: (arg0: PartialFilterType) => void }) => {
  const propertyTypeFilterRedux = useAppSelector((state) => state.filter.propertyTypes);
  const [propertyTypeFilter, setPropertyTypeFilter] = useOptimisticReducer(propertyTypeFilterRedux);
  const { apartment, condo, house, townhouse } = propertyTypeFilter;

  const handleFilterClick = (propertyType: keyof propertyTypesType) => {
    setPropertyTypeFilter({ type: propertyType, payload: !propertyTypeFilter[propertyType] });
    const newPropertyTypeFilter = assign({}, propertyTypeFilter);
    newPropertyTypeFilter[propertyType] = !propertyTypeFilter[propertyType];
    onFilterChange({ propertyTypes: newPropertyTypeFilter });
  };

  const component = (
    <FieldSet
      css={{ width: '100%', paddingBlock: '200' }}
      legend={
        <VisuallyHidden asChild>
          <Legend>Property type</Legend>
        </VisuallyHidden>
      }
    >
      {/* oxlint-disable-next-line constellation/no-raw-spacing-values -- `minWidth: 320px` is past the end of the numeric sizes scale, which stops at `5000` (200px) */}
      <Box css={{ minWidth: '320px', padding: '{spacing.100} {spacing.600}' }}>
        <LabeledControl
          controlId="homeType-houses"
          label={<Label>Houses</Label>}
          control={<Checkbox checked={house} onChange={() => handleFilterClick('house')} />}
        />
      </Box>
      {/* oxlint-disable-next-line constellation/no-raw-spacing-values -- `minWidth: 320px` is past the end of the numeric sizes scale, which stops at `5000` (200px) */}
      <Box css={{ minWidth: '320px', padding: '{spacing.100} {spacing.600}' }}>
        <LabeledControl
          controlId="homeType-condos"
          label={<Label>Condos/Co-ops</Label>}
          control={<Checkbox checked={condo} onChange={() => handleFilterClick('condo')} />}
        />
      </Box>
      {/* oxlint-disable-next-line constellation/no-raw-spacing-values -- `minWidth: 320px` is past the end of the numeric sizes scale, which stops at `5000` (200px) */}
      <Box css={{ minWidth: '320px', padding: '{spacing.100} {spacing.600}' }}>
        <LabeledControl
          controlId="homeType-apartments"
          label={<Label>Apartments</Label>}
          control={<Checkbox checked={apartment} onChange={() => handleFilterClick('apartment')} />}
        />
      </Box>
      {/* oxlint-disable-next-line constellation/no-raw-spacing-values -- `minWidth: 320px` is past the end of the numeric sizes scale, which stops at `5000` (200px) */}
      <Box css={{ minWidth: '320px', padding: '{spacing.100} {spacing.600}' }}>
        <LabeledControl
          controlId="homeType-townhomes"
          label={<Label>Townhomes</Label>}
          control={<Checkbox checked={townhouse} onChange={() => handleFilterClick('townhouse')} />}
        />
      </Box>
    </FieldSet>
  );

  return FilterWrapper({
    heading: 'Property Type',
    children: component,
  });
};

export default PropertyType;
